import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { DUPLICATE_SURVEY } from './constants';
import {
  IDuplicateSurveySuccess,
  IDuplicateSurveyError,
  DuplicateSurveyDataActionTypes,
  IDuplicateSurveyState,
} from './types';

const initialState: IDuplicateSurveyState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: DuplicateSurveyDataActionTypes,
  ): IDuplicateSurveyState => {
    switch (action.type) {
      case DUPLICATE_SURVEY + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case DUPLICATE_SURVEY + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as IDuplicateSurveySuccess).payload;
        break;
      }
      case DUPLICATE_SURVEY + FAILURE: {
        draft.status = rejected;
        draft.error = (action as IDuplicateSurveyError).error;
        break;
      }
      case DUPLICATE_SURVEY + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
